export default {
  fr: {
    SPENDESKFS_ACCOUNT: '512SFS',
  },
  others: {
    SPENDESKFS_ACCOUNT: '101SFS',
  },
};
